import script from "./ArticleParametersForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./ArticleParametersForm.vue?vue&type=script&setup=true&lang=ts"

import "./ArticleParametersForm.vue?vue&type=style&index=0&id=56ac9147&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56ac9147"]])

export default __exports__